export default __webpack_public_path__ + "static/media/2.060887d7.svg";